import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PlacanjeRacuna } from './placanje-racuna';

@Component({
  selector: 'app-placanje-racuna-modal-update',
  templateUrl: './placanje-racuna-modal-update.component.html'
})
export class PlacanjeRacunaModalUpdateComponent
extends BaseModalUpdateComponent<PlacanjeRacuna> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<PlacanjeRacuna>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
